var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "d-flex flex-column",
    class: "ma-".concat(_vm.margin),
    attrs: {
      "flat": "",
      "outlined": _vm.outlined,
      "min-width": "".concat(_vm.minWidth, "px"),
      "width": _vm.width,
      "min-height": _vm.height,
      "loading": _vm.loading
    }
  }, [!_vm.hideTitle ? _c('v-card-title', {
    staticClass: "title pt-4 text-truncate",
    class: _vm.gradientStyle ? 'white--text' : '',
    staticStyle: {
      "min-height": "68px"
    },
    style: _vm.gradientStyle
  }, [_c('h4', {
    staticClass: "text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-spacer'), _vm._t("actions"), _vm.isExpandable ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.isExpanded = !_vm.isExpanded;
      }
    }
  }, [_vm.isExpanded ? _c('v-icon', [_vm._v("mdi-chevron-down")]) : _c('v-icon', [_vm._v("mdi-chevron-up")])], 1) : _vm._e()], 2) : _vm._e(), _vm.subtitle ? _c('v-card-subtitle', {
    style: _vm.gradientStyle
  }, [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]) : _vm._e(), (_vm.subtitle || _vm.title) && !_vm.hideDivider ? _c('v-divider') : _vm._e(), _vm.isExpanded ? _c('div', [_vm._t("main"), _vm._t("default")], 2) : _vm._e(), _vm._t("card-actions")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }